module.exports = __webpack_public_path__ + "static/media/mitsubishi-icon-noneOption.6895db22.svg";